import { useEffect, useState } from 'react';

const NAV_LINKS = [
  { label: '私たちについて', href: '#philosophy' },
  { label: '事業内容', href: '#business' },
  { label: '大切にしていること', href: '#values' },
  { label: '代表メッセージ', href: '#ceo-message' },
  { label: '会社概要', href: '#company' },
  { label: 'お問い合わせ', href: '#contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? 'bg-[#FEFCFA] border-b border-[#E8DFD0]' : 'bg-transparent'
      }`}
    >
      <div className="max-w-6xl mx-auto px-8 h-16 flex items-center justify-between">
        <a
          href="#top"
          className="flex items-center gap-3 cursor-pointer"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }}
        >
          <img
            src="https://static.readdy.ai/image/a3e3ca399326711c48a35eb0fed7f5ed/2215a3aed99dae2ff591f5f8f33940f6.png"
            alt="Hug ロゴ"
            className="h-10 w-auto object-contain"
          />
          <span
            className={`font-semibold text-base tracking-wider transition-colors duration-300 ${
              scrolled ? 'text-[#3A2E28]' : 'text-white'
            }`}
            style={{ fontFamily: 'Noto Serif JP, serif' }}
          >
            Hug
          </span>
        </a>

        <div className="hidden md:flex items-center gap-8">
          {NAV_LINKS.map((link) => (
            <button
              key={link.href}
              onClick={() => handleNavClick(link.href)}
              className={`text-sm tracking-wider transition-colors duration-300 cursor-pointer whitespace-nowrap hover:opacity-60 ${
                scrolled ? 'text-[#3A2E28]' : 'text-white'
              }`}
            >
              {link.label}
            </button>
          ))}
        </div>

        <button
          className="md:hidden cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="メニュー"
        >
          <i
            className={`ri-menu-line text-2xl transition-colors duration-300 ${
              scrolled ? 'text-[#3A2E28]' : 'text-white'
            }`}
          />
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-[#FEFCFA] border-t border-[#E8DFD0] px-8 py-4 flex flex-col gap-4">
          {NAV_LINKS.map((link) => (
            <button
              key={link.href}
              onClick={() => handleNavClick(link.href)}
              className="text-sm tracking-wider text-[#3A2E28] text-left cursor-pointer hover:opacity-60 whitespace-nowrap"
            >
              {link.label}
            </button>
          ))}
        </div>
      )}
    </nav>
  );
}
